import {
    // BookOpen,
    X,
} from 'lucide-react';
// import { TEAMS } from './constants';

const shortText = (value, limit = 100) => {
    if (!value) return '';
    return value.length > limit ? `${value.slice(0, limit - 1)}...` : value;
};

export default function ShaktiBotPreviewCard({ onClose, onOpenChat, onOpenKnowledge, tip }) {
    return (
        <div className="mb-4 w-[360px] max-w-[calc(100vw-2rem)] rounded-3xl border border-outline-variant/70 bg-surface-container-lowest p-4 shadow-[0_24px_60px_rgba(27,28,23,0.14)]">
            <div className="flex items-start justify-between gap-3">
                <div>
                    <p className="text-[18px] font-black leading-tight text-on-surface">Did you know? Explore tips.</p>
                    {/* <p className="mt-2 text-sm font-semibold text-primary">Team Shakti is online</p> */}
                </div>
                <button
                    type="button"
                    aria-label="close bot"
                    onClick={onClose}
                    className="rounded-full p-1.5 text-on-surface/60 transition-colors hover:bg-surface-container-low hover:text-on-surface"
                >
                    <X className="h-5 w-5" />
                </button>
            </div>

            {/* <div className="mt-3 flex items-center justify-between gap-3">
                <div className="flex items-center -space-x-2">
                    {TEAMS.map((label, idx) => (
                        <div
                            key={label}
                            className="relative flex h-10 w-10 items-center justify-center rounded-full border-2 border-surface-container-lowest bg-secondary-container text-xs font-bold text-on-surface"
                            style={{ zIndex: 10 - idx }}
                        >
                            {label}
                            <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full border border-surface-container-lowest bg-primary" />
                        </div>
                    ))}
                </div>

                <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-[0_10px_24px_rgba(181,38,25,0.3)]">
                    <MessageCircle className="h-5 w-5" />
                </div>
            </div> */}

            {/* <div className="mt-4 grid grid-cols-2 gap-3">
                <button
                    type="button"
                    onClick={onOpenChat}
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-1 py-2 text-xs font-semibold text-white transition-colors hover:bg-[#9f1f14]"
                >
                    <MessageCircle className="h-4 w-4" />
                    Chat with the Team
                </button>
                <button
                    type="button"
                    onClick={onOpenKnowledge}
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-surface-container-low px-1 py-2 text-xs font-semibold text-on-surface transition-colors hover:bg-surface-container"
                >
                    <BookOpen className="h-4 w-4" />
                    Knowledge Base
                </button>

                <button
                    type="button"
                    onClick={onOpenKnowledge}
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-1 py-2 text-xs font-semibold text-white transition-colors hover:bg-[#9f1f14]"
                >
                    <BookOpen className="h-4 w-4" />
                    Knowledge Base
                </button>
            </div> */}

            {tip && (
                <div className="mt-4 rounded-2xl border border-outline-variant/70 bg-surface-container-low p-3">
                    <div className="text-[10px] font-black uppercase tracking-[0.18em] text-primary/80">Suggestion tip</div>
                    <div className="mt-2 text-sm font-bold text-on-surface">{tip.title}</div>
                    <p className="mt-1 text-xs leading-relaxed text-on-surface/80">{shortText(tip.textEn, 95)}</p>
                    <p className="mt-1 text-xs italic leading-relaxed text-on-surface/70">{shortText(tip.textHi, 95)}</p>
                </div>
            )}
        </div>
    );
}
